export default "__VITE_ASSET__Z2CK4QCV__"